import React from 'react';
import ModalDialog from '../AlmeDialog/ModalDialog';
import SyfLoader from 'syf-component-library/ui/atoms/Loader/SyfLoader';
const AlmeLoader = (props) => {
    return (!props.loaded
        ? React.createElement(ModalDialog, { id: 'iva-loader-dialog', ariaLabel: "loader", noBackground: true },
            React.createElement(SyfLoader, { size: 5 }))
        : null);
};
export default AlmeLoader;
